var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"7.2","height":"1.2","viewBox":"0 0 7.2 1.2"}},[_c('line',{attrs:{"id":"Line_703","data-name":"Line 703","x2":"6","transform":"translate(0.6 0.6)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-width":"1.2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }